import { useParams, useNavigate } from 'react-router-dom';
import { useQuestions } from '../stores/useQuestions';
import VideoTest from './VideoTest'; // Substitute for VideoRecorder
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function QuestionPage() {
  const { applicationId, questionId } = useParams<{ applicationId: string; questionId: string }>(); // Typed for safety
  const navigate = useNavigate();
  const questions = useQuestions((state) => state.questions);
  const currentIndex = questions.findIndex(q => q.id === questionId);
  const currentQuestion = questions[currentIndex];

  if (!currentQuestion) return <div>Question not found</div>;

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      navigate(`/interview/${applicationId}/question/${questions[currentIndex + 1].id}`);
    } else {
      alert('Interview complete!'); // Stub; redirect to dashboard
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-4 md:p-8">
      <h2 className="text-2xl font-bold mb-4">{currentQuestion.text}</h2>
      <VideoTest 
        applicationId={applicationId!} // FIXED: Pass required prop (real ID from params)
        question={currentQuestion} 
        onUploadSuccess={handleNext} // Auto-advance on upload
      />
      <div className="flex justify-end mt-4">
        <button 
          onClick={handleNext} 
          className="bg-[var(--primary)] text-txt-primary px-4 py-2 rounded flex items-center" 
          aria-label="Next question"
        >
          Next <ArrowRight className="ml-2" />
        </button>
      </div>
    </motion.div>
  );
}